export default __webpack_public_path__ + "content/media/36.d9d49ceb.jpg";